const competenceCards = [
  {
    color: '#d4b8b0',
    label: 'Clean Architecture',
    description: 'Modular, testable, and maintainable system design that scales with your needs.',
  },
  {
    color: '#bcc9bf',
    label: 'Performance Optimization',
    description: 'Relentless focus on efficiency, responsiveness, and resource-conscious engineering.',
  },
  {
    color: '#d5d3cf',
    label: 'Quality Assurance',
    description: 'Comprehensive testing strategies and code review practices for robust delivery.',
  },
  {
    color: '#d9c9a5',
    label: 'Continuous Innovation',
    description: 'Adoption of modern engineering standards and evolving internal processes.',
  },
];

export default function CompetenceSection() {
  return (
    <section className="relative bg-background-100 px-4 md:px-6 py-24 md:py-32">
      <div className="max-w-[1140px] mx-auto">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between mb-16">
          <div className="max-w-[480px]">
            <p className="font-heading text-sm italic text-foreground-500 mb-3">What we do</p>
            <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold text-foreground-950 leading-[1.15]">
              Core areas
              <br />
              <span className="italic font-light">of expertise</span>
            </h2>
          </div>
          <div className="hidden lg:flex items-center gap-2 mt-8 lg:mt-0">
            <span className="w-1 h-1 rounded-full bg-foreground-400" />
            <span className="w-1 h-1 rounded-full bg-foreground-500" />
            <span className="w-1 h-1 rounded-full bg-foreground-600" />
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {competenceCards.map((card, i) => (
            <div key={i} className="flex flex-col rounded-[24px] overflow-hidden" style={{ boxShadow: '0px 8px 24px rgba(0,0,0,0.04)' }}>
              <div
                className="h-[260px] w-full"
                style={{
                  background: `linear-gradient(180deg, ${card.color} 0%, ${card.color}dd 100%)`,
                }}
              />
              <div className="bg-white px-5 py-5">
                <p className="font-label text-sm font-semibold text-foreground-900 mb-1">{card.label}</p>
                <p className="font-body text-sm text-foreground-500 leading-relaxed">{card.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}